"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ERC20Module = void 0;
const CarbonSDK_1 = require("../CarbonSDK");
const base_1 = __importDefault(require("./base"));
class ERC20Module extends base_1.default {
    convertCoin(params, opts) {
        var _a, _b, _c, _d;
        return __awaiter(this, void 0, void 0, function* () {
            const wallet = this.getWallet();
            const coin = {
                denom: params.denom,
                amount: params.amount,
            };
            const value = CarbonSDK_1.Carbon.Erc20.MsgConvertCoin.fromPartial({
                coin,
                receiver: (_b = (_a = params.receiverAddress) === null || _a === void 0 ? void 0 : _a.toLowerCase()) !== null && _b !== void 0 ? _b : wallet.evmHexAddress.toLowerCase(),
                sender: (_d = (_c = params.senderAddress) === null || _c === void 0 ? void 0 : _c.toLowerCase()) !== null && _d !== void 0 ? _d : wallet.bech32Address.toLowerCase(),
            });
            return yield wallet.sendTx({
                typeUrl: CarbonSDK_1.CarbonTx.Types.MsgConvertCoin,
                value,
            }, opts);
        });
    }
    convertERC20(params, opts) {
        var _a, _b, _c, _d;
        return __awaiter(this, void 0, void 0, function* () {
            const wallet = this.getWallet();
            const value = CarbonSDK_1.Carbon.Erc20.MsgConvertERC20.fromPartial({
                contractAddress: params.contractAddress,
                amount: params.amount,
                receiver: (_b = (_a = params.receiverAddress) === null || _a === void 0 ? void 0 : _a.toLowerCase()) !== null && _b !== void 0 ? _b : wallet.bech32Address.toLowerCase(),
                sender: (_d = (_c = params.senderAddress) === null || _c === void 0 ? void 0 : _c.toLowerCase()) !== null && _d !== void 0 ? _d : wallet.bech32Address.toLowerCase(),
            });
            return yield wallet.sendTx({
                typeUrl: CarbonSDK_1.CarbonTx.Types.MsgConvertERC20,
                value,
            }, opts);
        });
    }
    registerToken(params, opts) {
        return __awaiter(this, void 0, void 0, function* () {
            const wallet = this.getWallet();
            const value = CarbonSDK_1.Carbon.Erc20.MsgRegisterToken.fromPartial({
                creator: params.creator,
                denom: params.denom,
            });
            return yield wallet.sendTx({
                typeUrl: CarbonSDK_1.CarbonTx.Types.MsgRegisterToken,
                value,
            }, opts);
        });
    }
    registerERC20(params, opts) {
        return __awaiter(this, void 0, void 0, function* () {
            const wallet = this.getWallet();
            const value = CarbonSDK_1.Carbon.Erc20.MsgRegisterERC20.fromPartial({
                creator: params.creator,
                contractAddress: params.contractAddress,
            });
            return yield wallet.sendTx({
                typeUrl: CarbonSDK_1.CarbonTx.Types.MsgRegisterERC20,
                value,
            }, opts);
        });
    }
}
exports.ERC20Module = ERC20Module;
